// Minimum password policy — keeps accounts reasonably secure by rejecting weak
// passwords. Used everywhere a password is set (signup, forced change, admin-created,
// reset link, profile). Returns an error string if too weak, or null if it passes.
export function passwordError(pw) {
  const p = pw || '';
  if (p.length < 8) return 'Password must be at least 8 characters.';
  if (!/[a-z]/.test(p)) return 'Password must include a lowercase letter.';
  if (!/[A-Z]/.test(p)) return 'Password must include an uppercase letter.';
  if (!/[0-9]/.test(p)) return 'Password must include a number.';
  if (/^(.)\1+$/.test(p)) return 'Password is too simple — avoid repeating a single character.';
  if (COMMON_WEAK.has(p.toLowerCase())) return 'That password is too common — please choose a stronger one.';
  return null;
}

// A short blocklist of obvious weak/common passwords (lowercased).
const COMMON_WEAK = new Set([
  'password', 'password1', 'password123', 'passw0rd', 'p@ssw0rd',
  '12345678', '123456789', '1234567890', 'qwerty123', 'iloveyou',
  'admin123', 'welcome1', 'letmein1', 'abc12345', 'changeme1',
]);

// Optional 0–4 strength score for a meter (not used for enforcement).
export function passwordScore(pw) {
  const p = pw || '';
  let s = 0;
  if (p.length >= 8) s++;
  if (p.length >= 12) s++;
  if (/[a-z]/.test(p) && /[A-Z]/.test(p)) s++;
  if (/[0-9]/.test(p) && /[^A-Za-z0-9]/.test(p)) s++;
  return Math.min(4, s);
}
